// Interfaces
import { MetaTag } from "interfaces/metaTag";

export const FORMAZIONE_PAGE = "/formazione";
export const ENVIRONMENT = process.env.NEXT_PUBLIC_GPO_ENVIRONMENT;
export const CACHE_TIME = 120; // time of caching initial APIs expressed in seconds
export const HOMEPAGE_URL = "/Default.aspx";
export const MOBILE_DEVICE_REGEX = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;
export const LINK_SPINNER = `${process.env.NEXT_PUBLIC_DOMAIN}/Images_net/loading.gif`;
export const GENERIC_GTM_ID = "GTM-53VFLLN";
export const TDM_META_TAGS: MetaTag[] = [{ name: 'tdm-reservation', content: '1'},{ name: 'tdm-policy', content: 'https://shop.altalex.com/policies/policy.json'}];
